<template>
  <div class="school-resource">
    <resource-menu :menu="menu" @menuChange="onMenuChange"></resource-menu>
    <div v-if="!detailShow" class="main-content">
      <div class="top-line">
        <div
          class="small-button"
          style="margin-right: 20px"
          @click="navigateBack"
        >
          返回
        </div>
        <!-- <el-select v-model="course" placeholder="请选择" @change="onCourseChange">
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="table-container">
        <el-table
          :data="data"
          style="width: 100%; margin-bottom: 10px"
          height="calc(100vh - 290px)"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">{{
              scope.$index + 1 + (page - 1) * 10
            }}</template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="资源标题"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tag"
            label="资源标签"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            width="width"
            align="center"
          >
            <template slot-scope="scope">{{
              getFileType(scope.row.urls)
            }}</template>
          </el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updated_at"
            label="更新时间"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column label="浏览/收藏/下载" width="200" align="center">
            <template slot-scope="scope">
              <div class="data">
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 17px; height: 12px"
                    :src="require('../../assets/view.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.views || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 15px; height: 14px"
                    :src="require('../../assets/collect.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.collect || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 14px; height: 14px"
                    :src="require('../../assets/download.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.download || 0) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="260" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <el-switch
                  :value="scope.row.shelf == 1"
                  active-color="#13ce66"
                  inactive-color="#cccccc"
                  style="margin-left: 12px"
                  @change="toShelf(scope.row)"
                >
                </el-switch>
                <div
                  :class="{
                    'seitch-tips': true,
                    'seitch-tips-on': scope.row.shelf == 1,
                  }"
                >
                  {{ scope.row.shelf == 1 ? '上架中' : '已下架' }}
                </div>
                <div style="display: flex; justify-content: center">
                  <div class="small-button" @click="toDetail(scope.row)">
                    查看
                  </div>
                </div>
                <!-- <div
                  style="
                    display: flex;
                    justify-content: center;
                    margin-left: 12px;
                  "
                >
                  <div
                    :class="{
                      'small-button': true,
                      'small-button2': scope.row.shelf == 1,
                    }"
                    @click="toShelf(scope.row)"
                  >
                    {{ scope.row.shelf == 1 ? '下架' : '上架' }}
                  </div>
                </div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="onPageChange"
          :current-page="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <resource-detail
      :show="detailShow"
      @onReturn="detailShow = false"
      @updateCollect="this.onUpdateCollect"
      @updateFollow="(val) => (detailData.follow = val)"
      detailType="2"
      :detailData="detailData"
      :isYNZY="true"
    ></resource-detail>
  </div>
</template>

<script>
import { getFileType } from '../../utils/utils'
import ResourceDetail from '../../components/resourceDetail.vue'
import resourceMenu from '../../components/resourceMenu.vue'
import {
  getTerm,
  getCourse,
  getResource,
  resourceShelf,
  resDetail,
} from '../../api/api'

export default {
  components: { resourceMenu, ResourceDetail },
  name: 'SchoolResource',
  data: () => ({
    menu: [],
    courseList: [],
    tagList: [],
    term: null,
    course: null,
    data: [
      // {
      //   name: '如何培养孩子的自信心',
      //   tag: '家庭教育',
      //   type: '视频',
      //   author: '欣欣老师',
      //   view: 45000,
      //   collect: 50000,
      //   download: 65000,
      // },
      // {
      //   name: '李玫瑾：教育的终极目的，是培养出快乐、温',
      //   tag: '家庭教育',
      //   type: '视频',
      //   author: '欣欣老师',
      //   view: 45000,
      //   collect: 50000,
      //   download: 65000,
      // },
      // {
      //   name: '睡前故事能起到什么作用',
      //   tag: '家庭教育',
      //   type: '视频',
      //   author: '欣欣老师',
      //   view: 45000,
      //   collect: 50000,
      //   download: 65000,
      // },
    ],
    page: 1,
    total: 0,
    detailShow: false,
    detailData: { content: [] },
    user: {},
    group1: null,
    group2: null,
    group3: null,
  }),
  mounted() {
    this.user = JSON.parse(localStorage.getItem('yey-user'))
    // getTerm().then((res) => {
    //   this.menu = res.data.data
    //   // 获取第一个学期的课程
    //   this.term = res.data.data[0]
    //   this.getCourseList(this.term)
    // })

    if (sessionStorage.getItem('yey-schoolResourceDetail')) {
      let searchDetail = JSON.parse(
        sessionStorage.getItem('yey-schoolResourceDetail')
      )
      this.detailShow = true
      setTimeout(() => {
        this.detailData = searchDetail
      }, 10)
    }
  },
  methods: {
    getFileType,
    // 获取课程以及加载第一个课程下的资源
    getCourseList(term) {
      // 获取课程
      getCourse(term).then((res) => {
        console.log(res)
        this.courseList = res.data.data
        if (res.data.data[0]) {
          this.course = res.data.data[0].id
          this.search(true)
        } else {
          this.course = ''
          this.data = []
        }
      })
    },
    // 搜索资源
    search(reset = false) {
      if (reset) {
        this.page = 1
      }
      let params = {
        page: this.page,
        // course_id: this.course,
        // term: this.term,
        status: 0,
        // range: this.user.school_id,
        range: 1,
      }

      // let params = { page: this.page, status: 0}
      // switch (this.typeIndex) {
      //   case 0: {
      //     params.is_gfpt = 1
      //     break
      //   }
      //   case 1: {
      //     params.is_gftj = 1
      //     break
      //   }
      //   case 2: {
      //     params.is_yzzy = 1
      //     break
      //   }
      //   case 3: {
      //     params.range = 1
      //     break
      //   }
      // }
      // if(this.tag) {
      //   params.tag = this.tag
      // }
      // if(this.sortIndex == 2) {
      //   params.sort = 'hot'
      // }
      if (this.group1) {
        params.group1 = this.group1
      }
      if (this.group2) {
        params.group2 = this.group2
      }
      if (this.group3) {
        params.group3 = this.group3
      }
      getResource(params).then((res) => {
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    onMenuChange(group1 = null, group2 = null, group3 = null) {
      // this.term = term
      // this.getCourseList(term)
      this.group1 = group1
      this.group2 = group2
      this.group3 = group3
      this.search(true)
    },
    onCourseChange() {
      this.search(true)
    },
    navigateBack() {
      this.$router.back()
    },
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    toDetail(row) {
      // this.detailData = row
      // this.detailShow = true

      resDetail(row.id).then((res) => {
        if (res.data.code == 0) {
          console.log('res', res)
          sessionStorage.setItem(
            'yey-schoolResourceDetail',
            JSON.stringify(res.data.data)
          )
          this.detailShow = true
          setTimeout(() => {
            this.detailData = res.data.data
          }, 10)
        }
      })
    },
    toShelf(row) {
      // console.log('toShelf', row)
      this.$confirm('确认下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resourceShelf({ id: row.id }).then((res) => {
          console.log('resourceShelf', res)
          if (this.data.length == 1 && this.page > 1) {
            this.page = this.page - 1
          }
          this.search()
        })
      })
    },
    onPageChange(e) {
      this.page = e
      this.search()
    },
    onUpdateCollect(val) {
      this.detailData.is_collect = val
      if (val) {
        console.log(111)
        this.$set(this.detailData, 'collect', this.detailData.collect + 1)
      } else {
        console.log(222)
        this.$set(this.detailData, 'collect', this.detailData.collect - 1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.school-resource {
  display: flex;
}
.main-content {
  box-sizing: border-box;
  width: calc(100vw - 220px);
  height: calc(100vh - 100px);
  padding-left: 20px;
  padding-bottom: 40px;
  overflow: auto;
}
.top-line {
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.small-button {
  width: 56px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid #00aeff;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: #00aeff;
  user-select: none;
  cursor: pointer;
}
.small-button2 {
  color: #808080;
  border: 1px solid #808080;
}
.table-container {
  padding: 20px;
  background-color: #fff;
}
.data {
  display: flex;
  justify-content: center;
  align-items: center;
  .data-item {
    margin-right: 29px;
    font-size: 14px;
    color: #4c4c4c;
    &:last-child {
      margin-right: 0;
    }
    .data-icon {
      margin-right: 4px;
    }
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  height: 30px;
}
.seitch-tips {
  flex-shrink: 0;
  margin-right: 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #808080;
  line-height: 20px;
}
.seitch-tips-on {
  color: #2bc17b;
}
</style>
